{
  "external_links": {
    "product_1": "https://yyyyy.com",
    "product_2": "https://yyyyy.com"
  }
}